export function verifyEmail (str: string) {
  const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
  return reg.test(str)
}
export function verifyPhone (str: string) {
  const reg = /^1[3-9][0-9]{9}$/
  return reg.test(str)
}
export function verifyUrl (str: string) {
  const reg = /(http|ftp|https):\/\/[\w\-_]+(.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?/
  return reg.test(str)
}
